/* Inclusive Barista header: square menu toggle. */
(function () {
  var header = document.querySelector('.ib-header');
  if (!header) return;
  var btn = header.querySelector('.ib-header__btn');
  if (!btn) return;

  function set(open) {
    header.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  btn.addEventListener('click', function () {
    set(!header.classList.contains('is-open'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') set(false);
  });
  document.addEventListener('click', function (e) {
    if (!header.contains(e.target)) set(false);
  });
})();
